import { EventPackageGetRequestParams } from "@lib/core";

export interface EventPackageDefaultParams extends EventPackageGetRequestParams { }
export class EventPackageDefaultParams {
  constructor() {
    this.select = "*,event_package_contents(id,qty,order,\
          event_package_reward_type(id,display_name),print_template(*,s3_file(*)))";
  }
}
